import { createReducer, on } from '@ngrx/store';
import {
  deleteDocuments,
  getDocuments,
  getDocumentsWithSorting,
  saveDocuments,
  updateDocuments,
  setDocuments,
  getFileContentDocuments,
  setFileContentDocuments,
  sentFileContentDocuments,
  sentDocuments,
  sentDeleteDocuments,
  getAttachmentContent,
  loaderDocument,
  getSidBasedDocument,
  setSidBasedDocument,
  getDocumentsBasedOnSearch,
  setDocumentsWithSorting,
  deleteAttachments
} from '../actions/documents.actions';

export interface DocumentsState {
  data: any;
  totalRecords: number;
  loader: boolean;
  newDocument: any;
  sidDocumentData: any;
}

export const initialState: DocumentsState = {
  data: [],
  totalRecords: 0,
  loader: true,
  newDocument: {},
  sidDocumentData: {}
};

export const documentsReducer = createReducer(
  initialState,
  on(getDocuments, (state) => ({
    ...state,
    loader: true
  })),
  on(setDocuments, (state, { documentsData, totalRecords }) => {
    const allDocs = [...documentsData];
    let parsedData: any[] = [];

    if (allDocs.length > 0) {
      parsedData = allDocs.map((doc) => {
        const parsedAttachments = doc.attachments ? JSON.parse(doc.attachments) : '';
        return { ...doc, parsedDocs: [...parsedAttachments] };
      });
    }
    return {
      ...state,
      data: parsedData,
      totalRecords: totalRecords,
      loader: false,
      sidDocumentData: {}
    };
  }),
  on(setDocumentsWithSorting, (state, { documentsData, totalRecords }) => {
    const allDocs = [...documentsData];
    let parsedData: any[] = [];

    if (allDocs.length > 0) {
      parsedData = allDocs.map((doc) => {
        const parsedAttachments = doc.attachments ? JSON.parse(doc.attachments) : '';
        return { ...doc, parsedDocs: [...parsedAttachments] };
      });
    }
    return {
      ...state,
      data: parsedData,
      totalRecords: totalRecords,
      loader: false,
      sidDocumentData: {}
    };
  }),
  on(sentDocuments, (state, { saveDocumentsData }) => {
    return {
      ...state,
      loader: false
    };
  }),
  on(saveDocuments, (state, { saveDocumentsData }) => {
    const parsedData = saveDocumentsData.attachments ? JSON.parse(saveDocumentsData.attachments) : '';
    const savedDocument = { ...saveDocumentsData, parsedDocs: [...parsedData] };

    let allData: any[] = [];
    if (savedDocument.sid) {
      allData = state.data.length > 0 ? [savedDocument, ...state.data] : [savedDocument];
    } else if (state.data.length > 0) {
      allData = [...state.data];
    }
    return {
      ...state,
      data: allData,
      totalRecords: state.totalRecords + 1,
      newDocument: saveDocumentsData,
      loader: false
    };
  }),
  on(updateDocuments, (state, { updateDocumentsData }) => {
    const parsedData = updateDocumentsData.attachments
      ? JSON.parse(updateDocumentsData.attachments)
      : [];
    const savedDocument = {
      ...updateDocumentsData,
      parsedDocs: [...parsedData]
    };
    const allData = state.data.map((document) =>
      document.sid === savedDocument.sid ? savedDocument : document
    );
    allData.sort(
      (a, b) => Number(b.createdDate || 0) - Number(a.createdDate || 0)
    );
    return {
      ...state,
      data: allData,
      newDocument: '',
      loader: false
    };
  }),
  on(sentDeleteDocuments, (state) => {
    return {
      ...state,
      loader: true
    };
  }),
  on(deleteDocuments, (state, { documentsId }) => {
    const allDocumentData = state.data;
    const filteredData = allDocumentData.filter((document: { sid: string }) => document.sid !== documentsId);
    return {
      ...state,
      data: filteredData,
      totalRecords: state.totalRecords > 0 ? state.totalRecords - 1 : 0,
      loader: false
    };
  }),
  on(getFileContentDocuments, (state) => {
    return {
      ...state,
      loader: true
    };
  }),
  on(getAttachmentContent, (state, { attachmentApiConstants, sid, id }) => {
    return {
      ...state,
      loader: false,
      ...{ attachmentApiConstants },
      ...{ sid },
      ...{ id }
    };
  }),
  on(setFileContentDocuments, (state, { documentContent, loader }) => {
    return {
      ...state,
      loader: loader,
      documentContent: documentContent
    };
  }),
  on(sentFileContentDocuments, (state, { apiConstants, sid, documentContent, attachments }) => {
    return {
      ...state,
      loader: false,
      ...{ apiConstants },
      ...{ sid },
      ...{ documentContent },
      ...{ attachments }
    };
  }),
  on(sentFileContentDocuments, (state, { apiConstants, sid, documentContent, attachments }) => {
    return {
      ...state,
      loader: false,
      ...{ apiConstants },
      ...{ sid },
      ...{ documentContent },
      ...{ attachments }
    };
  }),
  on(deleteAttachments, (state) => {
    return {
      ...state,
      loader: false
    };
  }),
  on(loaderDocument, (state, { loader }) => {
    return {
      ...state,
      loader: loader
    };
  }),
  on(getSidBasedDocument, (state) => {
    return {
      ...state,
      loader: true,
      sidDocumentData: {}
    };
  }),
  on(setSidBasedDocument, (state, { sidDocumentData }) => {
    const parsedData = sidDocumentData.attachments ? JSON.parse(sidDocumentData.attachments) : '';
    let savedDocument = {};
    if (sidDocumentData?.sid) {
      savedDocument = { ...sidDocumentData, parsedDocs: [...parsedData] };
    }

    return {
      ...state,
      loader: false,
      sidDocumentData: savedDocument
    };
  }),
  on(getDocumentsBasedOnSearch, (state) => {
    return {
      ...state,
      loader: true
    };
  })
);
